import { render, staticRenderFns } from "./ライセンス.vue?vue&type=template&id=3793b80a&scoped=true&"
import script from "./ライセンス.ts?vue&type=script&lang=ts&"
export * from "./ライセンス.ts?vue&type=script&lang=ts&"
import style0 from "./ライセンス.css?vue&type=style&index=0&id=3793b80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3793b80a",
  null
  
)

export default component.exports